export function decodeParamsFromUrl(str, paramName) {
  
  if (!str || !paramName) return null;
  // Separa por comas → ["analyticOrigin", "c2VydmljaW9z"]
  const parts = str.split(",");
  // Recorre de 2 en 2: [key, value]
  for (let i = 0; i < parts.length; i += 2) {
    const key = parts[i];
    const encoded = parts[i + 1];
    if (key === paramName) {
      try {
        return atob(encoded); // decodifica base64
      } catch (err) {
        console.error("Error decodificando Base64:", err);
        return null;
      }
    }
  }
  return null; // si no se encontró
}